module.exports = __webpack_public_path__ + "f8f2e5d1765cdd4d6c53282d8aa0257d.MP3";